import { useState } from 'react'
import { Header } from './components/Header'
import { Hero } from './components/Hero'
import { TopDestinos } from './components/TopDestinos'
import { Categorias } from './components/Categorias'
import { TopCompras } from './components/TopCompras'
import { TopMilhas } from './components/TopMilhas'
import { CTAAlertas } from './components/CTAAlertas'
import { Footer } from './components/Footer'
import type { Categoria } from './data'

export type CategoriaFiltro = Categoria | 'Todas'

function App() {
  const [categoria, setCategoria] = useState<CategoriaFiltro>('Todas')

  const selectAndScroll = (cat: CategoriaFiltro) => {
    setCategoria(cat)
    requestAnimationFrame(() => {
      document.getElementById('compras')?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    })
  }

  return (
    <main className="overflow-x-hidden">
      <Header />
      <Hero />
      <TopDestinos />
      <Categorias onSelect={selectAndScroll} />
      <TopCompras categoria={categoria} setCategoria={setCategoria} />
      <TopMilhas />
      <CTAAlertas />
      <Footer />
    </main>
  )
}

export default App
